<avla-modal name="updateUser" type="right" [icon]="{ type: 'class', icon: 'close', class: 'material-symbols-rounded' }">
    <div class="avla_modal_section__header mt-16 flex flex-col items-center">
      <span class="material-symbols-rounded"> person_add </span>
      <p class="text-2xl font-semibold text-light-blue">
        Editar usuario
      </p>
    </div>
    <div class="avla_modal_section__body" [ngClass]="{'overflow-y-scroll max-h-[50vh]': height <= 680}">
      <form [formGroup]="updateUserForm">
        <div class="w-[380px] mx-auto flex flex-col gap-4">
          <avla-input [form]="updateUserForm" id="rut" type="rut" label="RUT"
            [required]="true" [disabled]="true"></avla-input>
          <avla-input [form]="updateUserForm" id="firstName" type="text" label="Primer nombre"
            [required]="true" [disabled]="true"></avla-input>
          <avla-input [form]="updateUserForm" id="secondName" type="text" label="Segundo nombre"
            [disabled]="true"></avla-input>
          <avla-input [form]="updateUserForm" id="fatherLastname" type="text" label="Apellido paterno"
            [required]="true" [disabled]="true"></avla-input>
          <avla-input [form]="updateUserForm" id="motherLastname" type="text" label="Apellido materno"
            [required]="true" [disabled]="true"></avla-input>
          <avla-input [form]="updateUserForm" id="email" type="text" label="Correo"
            [required]="true" [disabled]="true"></avla-input>
            <avla-select
            [form]="updateUserForm"
            [values]="roles"
            id="role"
            [arrow]="{
              type: 'class',
              icon: 'expand_more',
              change: '',
              class: 'material-symbols-rounded',
              error: ''
            }"
            label="Rol de usuario"
            [required]="true"
          ></avla-select>
          <avla-button
            class="avla-btn-primary avla-btn-flat-label-md flat-design-button mx-auto"
            [disabled]="updateUserForm.invalid"
            theme="primary"
            label="Editar"
            (click)="update()"
          ></avla-button>
        </div>
      </form>
    </div>
  </avla-modal>